import React from 'react';
import { Sparkles, Zap, TrendingUp, ShieldCheck } from 'lucide-react';
import { Button } from './ui/button';
import ApptonomyMockup from './ApptonomyMockup';

const iconMap = { Sparkles, Zap, TrendingUp, ShieldCheck };

const Hero = ({ onStartProject }) => {
  const badges = [
    { icon: 'Sparkles', label: 'AI-Powered' },
    { icon: 'Zap', label: 'Lightning Fast' },
    { icon: 'TrendingUp', label: 'Scale Without Limits' },
    { icon: 'ShieldCheck', label: 'Secure & Reliable' },
  ];

  return (
    <section className="relative pt-32 pb-16 overflow-hidden">
      {/* Radial glow background */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-[10%] left-[15%] w-[500px] h-[500px] rounded-full bg-[#7c3aed]/20 blur-[120px]" />
        <div className="absolute top-[20%] right-[10%] w-[500px] h-[500px] rounded-full bg-[#4f46e5]/15 blur-[120px]" />
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,transparent_0%,#05050a_75%)]" />
      </div>

      <div className="relative max-w-[1280px] mx-auto px-6 lg:px-8 grid lg:grid-cols-2 gap-10 items-center">
        {/* LEFT */}
        <div>
          <div className="text-[11px] tracking-[0.3em] font-semibold mb-6">
            <span className="bg-gradient-to-r from-[#a855f7] to-[#60a5fa] bg-clip-text text-transparent">
              AI • SOFTWARE • AUTOMATION
            </span>
          </div>

          <h1 className="text-white font-bold leading-[1.05] tracking-tight text-[44px] lg:text-[56px]">
            We Build. You Scale.
            <br />
            Technology That
            <br />
            <span className="bg-gradient-to-r from-[#c084fc] via-[#a855f7] to-[#7c3aed] bg-clip-text text-transparent">
              Moves Your Business.
            </span>
          </h1>

          <p className="mt-6 text-gray-400 text-[15px] leading-relaxed max-w-[540px]">
            BLKPixel Technologies is a software company, product builder, and AI-powered development studio. We build powerful applications, platforms, and tools that help businesses work smarter, grow faster, and dominate their markets.
          </p>

          <div className="mt-8 flex flex-wrap gap-3">
            <Button
              onClick={onStartProject}
              data-testid="hero-start-project-btn"
              className="h-11 px-6 rounded-md text-sm font-semibold bg-gradient-to-r from-[#7c3aed] to-[#4f46e5] hover:from-[#8b45f0] hover:to-[#5b52ee] text-white shadow-[0_0_25px_rgba(124,58,237,0.4)] border-0"
            >
              Start Your Project
            </Button>
            <Button
              variant="outline"
              onClick={() => document.getElementById('products')?.scrollIntoView({ behavior: 'smooth' })}
              data-testid="hero-explore-products-btn"
              className="h-11 px-6 rounded-md text-sm font-semibold bg-white/5 border border-white/10 text-white hover:bg-white/10 hover:text-white"
            >
              Explore Our Products
            </Button>
          </div>

          <div className="mt-8 flex flex-wrap gap-x-6 gap-y-3">
            {badges.map((b) => {
              const Icon = iconMap[b.icon];
              return (
                <div key={b.label} className="flex items-center gap-2 text-[12.5px] text-gray-400">
                  <Icon className="w-3.5 h-3.5 text-[#a855f7]" />
                  {b.label}
                </div>
              );
            })}
          </div>
        </div>

        {/* RIGHT - Apptonomy mockup */}
        <div className="relative">
          <ApptonomyMockup />
        </div>
      </div>
    </section>
  );
};

export default Hero;
